module.exports = __webpack_public_path__ + "img/madlena-tsvetkova-l.0ac3c210.jpg";